import React from 'react';
import '../css/footer.css';
import CareerGradient from '../../../../page-module/page-services/career/ts/careerGradient';
import { useCmsGlobals } from '../../../../context-module/context-configuration/auth-provider/appShell/appShellGlobal/appUseGlData';

interface FooterProps {
  logoIcon?: React.ReactNode | string;
  logoAlt?: string;
}

const FooterRouteMap: Record<number, string> = {
  1: '/contact/business-contact',
  2: '/contact/sales-contact',
  3: '/career',
};

export const mapContactCardsFromCMS = (
  lists: any[],
  navigate: (path: string) => void
) => {
  return lists.map((item) => ({
    title: item.title,
    onButtonClick: () => navigate(FooterRouteMap[item.id]),
  }));
};

const Footer: React.FC<FooterProps> = ({
  logoIcon,
  logoAlt = "Logo",
}) => {
  const { globals, loading } = useCmsGlobals() //NOSONAR
  const cmsFooter = globals?.footer ?? null;

  const cmsFooterData = cmsFooter?.cta?.[0]?.layout?.content?.[0]

  const renderLogo = () => {
    if (typeof logoIcon === 'string') {
      return (
        <>
          {cmsFooterData?.headerSection?.visible ?
            <img
              src={cmsFooterData?.headerSection?.imgLogo}
              alt={cmsFooterData?.headerSection?.imgAlt}
              className="scl--web-component-footer-logo-image"
              onError={(e) => {
                (e.currentTarget as HTMLImageElement).src = logoIcon;
              }}
            />
            :
            <img
              src={logoIcon}
              alt={logoAlt}
              className="scl--web-component-footer-logo-image"
            />
          }
        </>

      )

    }

    if (logoIcon) {
      return logoIcon;
    }

    return (
      <div className="scl--web-component-footer-default-icon">
        <div className="scl--web-component-footer-icon-bar" />
        <div className="scl--web-component-footer-icon-bar" />
        <div className="scl--web-component-footer-icon-bar" />
      </div>
    );
  };

  return (
    <>
      {cmsFooter?.visible &&
        <footer className="scl--web-component-footer">
          <CareerGradient />

          <div className="scl--web-component-footer-content">
            <div className="scl--web-component-footer-logo-section">
              <div className="scl--web-component-footer-icon-container">
                {renderLogo()}
              </div>
              {cmsFooterData?.headerSection?.visible &&
                <h2 className="scl--web-component-footer-tagline">{cmsFooterData?.headerSection?.title}</h2>
              }
            </div>

            <div className="scl--web-component-footer-bottom">
              {cmsFooterData?.footerLeft?.visible &&
                <p className="scl--web-component-footer-copyright">{cmsFooterData?.footerLeft?.title}</p>
              }
            </div>
          </div>
        </footer>
      }
    </>
  );
};

export default Footer;